var _path, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBackgroundVetor(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1600,
    height: 150,
    viewBox: "0 0 1600 150",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0 141.914L24 145.293C48 148.672 97.3333 155.43 145.333 141.914C193.333 128.399 242.667 94.6096 290.667 84.4729C340 74.3361 388 87.8518 436 91.2307C485.333 94.6096 533.333 87.8518 581.333 77.715C630.667 67.5783 678.667 54.0626 726.667 60.8205C776 67.5783 824 94.6096 873.333 104.746C921.333 114.883 969.333 108.125 1018.67 97.9885C1066.67 87.8518 1114.67 74.3361 1164 60.8205C1212 47.3048 1260 33.7891 1309.33 54.0626C1357.33 74.3361 1406.67 128.399 1454.67 141.914C1502.67 155.43 1552 128.399 1576 114.883L1600 101.367V0H1576C1552 0 1502.67 0 1454.67 0C1406.67 0 1357.33 0 1309.33 0C1260 0 1212 0 1164 0C1114.67 0 1066.67 0 1018.67 0C969.333 0 921.333 0 873.333 0C824 0 776 0 726.667 0C678.667 0 630.667 0 581.333 0C533.333 0 485.333 0 436 0C388 0 340 0 290.667 0C242.667 0 193.333 0 145.333 0C97.3333 0 48 0 24 0H0V141.914Z",
    fill: "url(#paint0_linear_201_3)",
    fillOpacity: 0.5
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_201_3",
    x1: 1600,
    y1: 56.5004,
    x2: 23.3962,
    y2: 79.3388,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#96F6B1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#96B1F6"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBackgroundVetor);
export default __webpack_public_path__ + "static/media/background_vetor.684a8ae6eb56a8bc34364b0ada40cbed.svg";
export { ForwardRef as ReactComponent };